// extracted by mini-css-extract-plugin
module.exports = {"objectPage":"objectPage_objectPage__188DW","objects":"objectPage_objects__3IBi1"};